export const GoldDivider = ({ testid }) => (
  <div
    data-testid={testid}
    className="flex items-center justify-center gap-3 py-1"
    aria-hidden="true"
  >
    <span className="h-px w-14 bg-gradient-to-r from-transparent via-[#E5D5B8] to-[#C9A94E] sm:w-20" />
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M12 2.5 L21.5 12 L12 21.5 L2.5 12 Z" stroke="#B8860B" strokeWidth="1.1" />
      <circle cx="12" cy="12" r="2.2" fill="#D4AF37" />
    </svg>
    <span className="h-px w-14 bg-gradient-to-l from-transparent via-[#E5D5B8] to-[#C9A94E] sm:w-20" />
  </div>
);

export const SectionDivider = ({ testid }) => (
  <div
    data-testid={testid}
    className="flex items-center justify-center gap-4"
    aria-hidden="true"
  >
    <span className="h-px flex-1 bg-gradient-to-r from-transparent via-[#EBDFC4] to-[#C9A94E]" />
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
      <path d="M12 3 L21 12 L12 21 L3 12 Z" stroke="#B8860B" strokeWidth="1.1" />
      <circle cx="12" cy="12" r="1.8" fill="#D4AF37" />
    </svg>
    <span className="h-px flex-1 bg-gradient-to-l from-transparent via-[#EBDFC4] to-[#C9A94E]" />
  </div>
);

export const CornerFlourish = ({ className = "" }) => (
  <svg
    className={`pointer-events-none ${className}`}
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    aria-hidden="true"
  >
    <path d="M1 41 V13 Q1 1 13 1 H41" stroke="#C9A94E" strokeWidth="1" />
    <path d="M6 41 V17 Q6 6 17 6 H41" stroke="#E5D5B8" strokeWidth="0.75" />
    <circle cx="9.2" cy="9.2" r="1.5" fill="#D4AF37" />
  </svg>
);

export const FloralOrnament = ({ className = "" }) => (
  <svg
    className={className}
    width="120"
    height="28"
    viewBox="0 0 120 28"
    fill="none"
    aria-hidden="true"
  >
    <circle cx="60" cy="14" r="3" stroke="#B8860B" strokeWidth="0.9" />
    <circle cx="60" cy="14" r="1" fill="#D4AF37" />
    <path
      d="M56 14 C46 12 38 10 28 12 M46 12.6 C44 10 41 8.5 38 8.5 M46 12.6 C44.5 15 42 16.5 39.5 16.8 M34 11.3 C32.5 9 30 7.8 27.5 8 M34 11.3 C32.8 13.6 30.5 15 28.2 15.2"
      stroke="#C9A94E"
      strokeWidth="0.8"
      strokeLinecap="round"
    />
    <path d="M22 12.5 L14 13.5" stroke="#C9A94E" strokeWidth="0.8" strokeLinecap="round" />
    <path
      d="M64 14 C74 12 82 10 92 12 M74 12.6 C76 10 79 8.5 82 8.5 M74 12.6 C75.5 15 78 16.5 80.5 16.8 M86 11.3 C87.5 9 90 7.8 92.5 8 M86 11.3 C87.2 13.6 89.5 15 91.8 15.2"
      stroke="#C9A94E"
      strokeWidth="0.8"
      strokeLinecap="round"
    />
    <path d="M98 12.5 L106 13.5" stroke="#C9A94E" strokeWidth="0.8" strokeLinecap="round" />
    <circle cx="11" cy="13.7" r="1" fill="#D4AF37" />
    <circle cx="109" cy="13.7" r="1" fill="#D4AF37" />
  </svg>
);
